(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("react-addons-transition-group"));
	else if(typeof define === 'function' && define.amd)
		define("Reactstrap", ["react", "react-dom", "react-addons-transition-group"], factory);
	else if(typeof exports === 'object')
		exports["Reactstrap"] = factory(require("react"), require("react-dom"), require("react-addons-transition-group"));
	else
		root["Reactstrap"] = factory(root["React"], root["ReactDOM"], root["React"]["addons"]["TransitionGroup"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_70__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/